import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import AIFeatures from "@/components/AIFeatures";
import Stats from "@/components/Stats";
import References from "@/components/References";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#050505] text-[#F5F5F5]">
      <Header />
      <Hero />
      <Marquee />
      <Services />
      <AIFeatures />
      <Stats />
      <References />
      <Pricing />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
